import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import Pagination from '@com/components/pagination/index.vue';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import { parseTime } from '@/filters/index';
import { fetchWhitelist } from '@/api/monitor/mid-whitelist';
import { deleteWhitelist } from '@/api/monitor/mid-whitelist';
import { createWhitelist } from '@/api/monitor/mid-whitelist';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import qs from 'qs';

export default {
  data: function data() {
    return {
      listLoading: false,
      query: {
        page: 1,
        page_size: 15,
        mid: ''
      },
      pagination: {
        total: 0
      },
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        id: '',
        mid: '',
        created_time: ''
      },
      formLabelWidth: '120px',
      formItemList: [{
        type: 'input',
        prop: 'mid',
        subtype: 'text',
        params: {
          clearable: true,
          placeholder: '请输入mid'
        }
      }],
      tableData: [{
        id: '123',
        mid: '1',
        created_time: '2021-08-16'
      }, {
        id: '124',
        mid: '2',
        created_time: '2021-08-17'
      }, {
        id: '125',
        mid: '3',
        created_time: '2021-08-18'
      }, {
        id: '126',
        mid: '4',
        created_time: '2021-08-19'
      }]
    };
  },

  components: {
    SearchBar: SearchBar,
    Pagination: Pagination
  },
  watch: {
    $route: function $route(to, from) {
      this.getAdxList(this.query);
    }
  },
  methods: {
    handleExport: function handleExport() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  downloadWithNewWindow(v2Host + '/monitor/mid-whitelist/export?' + qs.stringify(_this.query));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAdxList: function getAdxList(query) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var postData, res, i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                postData = _extends({}, query);

                _this2.listLoading = true;
                _context2.prev = 2;
                _context2.next = 5;
                return fetchWhitelist(postData);

              case 5:
                res = _context2.sent;


                _this2.tableData = _.get(res, 'data.data.list');

                for (i = 0; i < _this2.tableData.length; i++) {
                  _this2.tableData[i].created_time = parseTime(_this2.tableData[i].created_time, '{y}-{m}-{d} {h}:{i}:{s}');
                }
                _this2.pagination.total = _.get(res, 'data.data.total');
                // console.log(this.pagination.total)
                _this2.listLoading = false;
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](2);

                console.log(_context2.t0);
                _this2.listLoading = false;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 12]]);
      }))();
    },
    handleDelete: function handleDelete(mid) {
      var _this3 = this;

      this.$confirm('是否确认删除当前adx白名单？', '提示', {
        type: 'warning'
      }).then(function () {
        _this3.handleAdxItem(mid);
      }).catch(function () {
        //
      });
    },
    handleAdxItem: function handleAdxItem(mid) {
      var _this4 = this;

      deleteWhitelist({
        mids: mid
      }).then(function (res) {
        _this4.$message({
          message: '删除成功',
          type: 'success'
        });
        _this4.getAdxList(_this4.query);
      }).catch(function (err) {});
    },
    showDialog: function showDialog() {
      this.dialogFormVisible = true;
      this.form.mid = '';
    },
    submitDialog: function submitDialog(mid) {
      var _this5 = this;

      this.dialogFormVisible = false;
      createWhitelist({
        mids: mid
      }).then(function (res) {
        _this5.$message({
          message: '添加成功',
          type: 'success'
        });
        _this5.getAdxList(_this5.query);
      }).catch(function (err) {});
    }
  },
  mixins: [searchMixin],
  mounted: function mounted() {
    this.getAdxList(this.query);
    // console.log(this.$refs.created_time.innerHTML)
    // this.$refs.created_time.innerHTML = parseTime(this.created_time,'{y}-{m}-{d} {h}:{i}:{s}')
  }
};